function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("View a "),_c('router-link',{attrs:{"to":"/globe?view=%2Fsample_small.csv"}},[_vm._v("simple sample globe")]),_vm._v(" or a "),_c('router-link',{attrs:{"to":"/globe?view=%2Fsample.csv"}},[_vm._v("complex sample globe")]),_vm._v(".")],1),_vm._v(" "),_c('p',[_vm._v("You can access a sample dataset and work through our "),_c('router-link',{attrs:{"to":"/tutorial"}},[_vm._v("tutorial")]),_vm._v(" for more information.")],1),_vm._v(" "),_c('p',[_vm._v("Please note that this site has been optimized for use in Chrome or Safari.")]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('img',{attrs:{"src":require("./tutorial/globe_example.svg"),"alt":"globe example"}})])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }